import {
  Archive,
  BarChart3,
  Bell,
  BookOpen,
  BriefcaseBusiness,
  Building2,
  CircleDollarSign,
  ClipboardCheck,
  ClipboardList,
  FileText,
  Gauge,
  GraduationCap,
  Home,
  Image,
  Landmark,
  MapPinned,
  Newspaper,
  Settings,
  Shield,
  ShieldCheck,
  Trash2,
  Users,
  type LucideIcon,
} from "lucide-react";

export const PANEL_ROUTE_ICONS: Record<string, LucideIcon> = {
  "/dashboard": Gauge,
  "/icerik": ClipboardCheck,
  "/anasayfa": Home,
  "/hero": MapPinned,
  "/sayfalar": FileText,
  "/hizmetler": BriefcaseBusiness,
  "/finansman": CircleDollarSign,
  "/karsilastirmalar": BarChart3,
  "/blog": Newspaper,
  "/egitim": GraduationCap,
  "/kurumsal": Building2,
  "/referanslar": Landmark,
  "/firsatlar": Landmark,
  "/firsat-talepleri": ClipboardList,
  "/firsat-ayarlari": Settings,
  "/medya": Image,
  "/basvurular": ClipboardList,
  "/uyeler": Users,
  "/bulten": BookOpen,
  "/kullanicilar": ShieldCheck,
  "/roller": Shield,
  "/denetim": Archive,
  "/cop-kutusu": Trash2,
  "/ayarlar": Settings,
  "/bildirimler": Bell,
  "/editorial": Newspaper,
};

export function panelIconForPath(pathname: string): LucideIcon {
  const route = Object.keys(PANEL_ROUTE_ICONS)
    .sort((left, right) => right.length - left.length)
    .find((candidate) => pathname === candidate || pathname.startsWith(`${candidate}/`));
  return (route && PANEL_ROUTE_ICONS[route]) || FileText;
}
